import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

/**
 * Async Thunks for EmailLog API Calls
 */

// Fetch email logs with filters and pagination
export const getEmailLogs = createAsyncThunk(
  'emailLogs/getEmailLogs',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await api.get('/admin/email-logs', { params });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: error.message }
      );
    }
  }
);

// Fetch single email log by ID
export const getEmailLogById = createAsyncThunk(
  'emailLogs/getEmailLogById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.get(`/admin/email-logs/${id}`);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: error.message }
      );
    }
  }
);

// Retry sending a failed email
export const retryEmail = createAsyncThunk(
  'emailLogs/retryEmail',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.post(`/admin/email-logs/${id}/retry`);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: error.message }
      );
    }
  }
);

/**
 * EmailLog Slice
 */
const emailLogSlice = createSlice({
  name: 'emailLogs',
  initialState: {
    emailLogs: [],
    currentEmailLog: null,
    loading: false,
    error: null,
    pagination: {
      page: 1,
      limit: 10,
      total: 0,
      totalPages: 0
    }
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearCurrentEmailLog: (state) => {
      state.currentEmailLog = null;
    }
  },
  extraReducers: (builder) => {
    // getEmailLogs
    builder
      .addCase(getEmailLogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getEmailLogs.fulfilled, (state, action) => {
        state.loading = false;
        state.emailLogs = action.payload.emailLogs;
        state.pagination = {
          page: action.payload.page,
          limit: action.payload.limit,
          total: action.payload.total,
          totalPages: action.payload.totalPages
        };
      })
      .addCase(getEmailLogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Email logları yüklenemedi';
      });

    // getEmailLogById
    builder
      .addCase(getEmailLogById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getEmailLogById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentEmailLog = action.payload;
      })
      .addCase(getEmailLogById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Email log yüklenemedi';
      });

    // retryEmail
    builder
      .addCase(retryEmail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(retryEmail.fulfilled, (state, action) => {
        state.loading = false;
        // Update the email log in the list if it exists
        const index = state.emailLogs.findIndex(
          log => log._id === action.payload._id
        );
        if (index !== -1) {
          state.emailLogs[index] = action.payload;
        }
      })
      .addCase(retryEmail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Email tekrar gönderilemedi';
      });
  }
});

export const { clearError, clearCurrentEmailLog } = emailLogSlice.actions;
export default emailLogSlice.reducer;

